(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/result/views/result.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/result/views/result.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.vikinglotto=_svs.vikinglotto||{};
_svs.vikinglotto.components=_svs.vikinglotto.components||{};
_svs.vikinglotto.components.result=_svs.vikinglotto.components.result||{};
_svs.vikinglotto.components.result.templates=_svs.vikinglotto.components.result.templates||{};
svs.vikinglotto.components.result.templates.result = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"resultContentRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-vikinglotto-components-result-result'] = svs.vikinglotto.components.result.templates.result;
})(svs, Handlebars);

 })(window);